import React from "react";
import IconSpotify from "./icons/spotify";
import HomeIcon from "@mui/icons-material/Home";
import HistoryIcon from "@mui/icons-material/History";
import { Menu, MenuItem } from "@mui/material";
import { logout } from "../spotify";

const LOGIN_URI =
  process.env.NODE_ENV !== "production"
    ? "http://localhost:3000/login"
    : "https://spotlight-web-nnyz.vercel.app/login";

const LOGOUT_URI =
  process.env.NODE_ENV !== "production"
    ? "http://localhost:3000/logout"
    : "https://spotlight-web-nnyz.vercel.app/logout";

export default function Navbar({ currPage, setCurrPage, token }) {
  // Determine if user is authenticated
  const isAuthenticated = Boolean(token && token !== "undefined");

  return (
    <nav
      className={`
        fixed z-[99]
        flex flex-col md:flex-col justify-between items-center
        w-full md:w-fit
        min-h-[60px] md:min-h-screen
        bottom-0 md:top-0 left-0
        bg-[#040306] text-white text-center
        shadow-[0_0_10px_rgba(0,0,0,0.3)]
        font-medium font-inter
        md:rounded-none rounded-t-2xl
        md:flex-col flex-row
        md:py-2 py-4
      `}
      style={{ pointerEvents: "auto" }}
    >
      {/* Top: Spotify Icon and Spotlight */}
      <div className="hidden md:flex flex-col items-center gap-4 mt-4 px-10">
        <IconSpotify />
        <span className="text-2xl font-bold tracking-wide">Spotlight</span>
      </div>
      <div className="flex flex-row md:flex-col items-center gap-8 md:gap-4 w-full justify-center md:justify-start">
        <button
          className={`
          flex flex-col items-center gap-1 w-full md:w-full
          transition-colors
          md:hover:border-l-6 md:hover:border-[#1DB954]
          md:border-l-4 md:border-transparent
          hover:border-b-4 hover:border-[#1DB954] md:hover:border-b-0
          py-2
          ${
            currPage === "today"
              ? "text-[#1DB954] md:border-l-[#1DB954] border-b-4 border-[#1DB954] md:border-b-0"
              : ""
          }
            `}
          aria-label="Home"
          style={{ color: "inherit", backgroundColor: "inherit" }}
          onClick={() => setCurrPage("today")}
        >
          <HomeIcon fontSize="medium" />
          <span className="text-xs">Home</span>
        </button>
        <button
          className={`
          flex flex-col items-center gap-1 w-full md:w-full 
          transition-colors
          md:hover:border-l-6 md:hover:border-[#1DB954]
          md:border-l-4 md:border-transparent
          hover:border-b-4 hover:border-[#1DB954] md:hover:border-b-0
          py-2
          ${
            currPage === "history"
              ? "text-[#1DB954] md:border-l-[#1DB954] border-b-4 border-[#1DB954] md:border-b-0"
              : ""
          }
            `}
          aria-label="History"
          style={{ color: "inherit", backgroundColor: "inherit" }}
          onClick={() => setCurrPage("history")}
        >
          <HistoryIcon fontSize="medium" />
          <span className="text-xs">History</span>
        </button>
      </div>
      {/* Bottom: Login or Logout Button */}
      <div className="w-full px-4 py-4 md:block flex justify-end items-center">
        {!isAuthenticated ? (
          <a
            href={LOGIN_URI}
            className="bg-[#1DB954] text-white rounded-full px-4 py-2 font-bold text-sm shadow-md hover:bg-[#1ed760] transition-colors w-full md:w-full md:max-w-[200px] flex items-center justify-center"
          >
            Log in
          </a>
        ) : (
          <button
            onClick={logout}
            className="bg-[#1DB954] text-white rounded-full px-4 py-2 font-bold text-sm shadow-md hover:bg-[#1ed760] transition-colors w-full md:w-full md:max-w-[200px] flex items-center justify-center"
          >
            Logout
          </button>
        )}
      </div>
    </nav>
  );
}
